// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9f77d3f0","239":"b79d72ec","453":"da1797df","667":"611a9b57"}[chunkId] + ".chunk.js";
};